import { fromJS } from "immutable";

const defaultState = fromJS({
  lblist: [],
  modulelist: [],
  cplists: [],
  totalpage: 0,
  num: 0,
  type1: "",
  type2: "",
  type1id: "",
  type2id: "",
  typeid: "",
  mid: "",
  kwd: "",
  price: "",
  page: 1,
  pricearr: [],
  viewstyle: "window",
  pagetitle: "",
});
const todo = (state = defaultState, action) => {
  switch (action.type) {
    case "change_module_data": {
      // const newState = JSON.parse(JSON.stringify(state));
      //newState.topicList = action.topicList;
      // newState.articleList = action.articleList;
      // newState.recommendList = action.recommendList;

      // return newState;
      return state.merge({
        modulelist: action.modulelist,
        totalpage: action.totalpage,
        num: action.num,

        page: action.page,
      });
      //    return state.set('topicList',fromJS(action.topicList)).set('articleList',fromJS(action.articleList)).set('recommendList',fromJS(action.recommendList));
    }
    case "change_type_data": {
      // const newState = JSON.parse(JSON.stringify(state));
      //newState.topicList = action.topicList;
      // newState.articleList = action.articleList;
      // newState.recommendList = action.recommendList;

      // return newState;
      return state.merge({
        lblist: action.lblist,
        totalpage: action.totalpage,
        num: action.num,
        cplists: action.cplists,
        type1: action.type1,
        type2: action.type2,
        type1id: action.type1id,
        type2id: action.type2id,
        typeid: action.typeid,
        mid: action.mid,
        kwd: action.kwd,
        price: action.price,
        page: action.page,
        pricearr: action.pricearr,
        pagetitle: action.pagetitle,
      });
      //    return state.set('topicList',fromJS(action.topicList)).set('articleList',fromJS(action.articleList)).set('recommendList',fromJS(action.recommendList));
    }
    case "change_type_view": {
      // const newState = JSON.parse(JSON.stringify(state));
      //newState.topicList = action.topicList;
      // newState.articleList = action.articleList;
      // newState.recommendList = action.recommendList;

      // return newState;
      return state.merge({
        viewstyle: action.viewstyle,
      });
      //    return state.set('topicList',fromJS(action.topicList)).set('articleList',fromJS(action.articleList)).set('recommendList',fromJS(action.recommendList));
    }
    default: {
      return state;
    }
  }
  //return state;
};
export default todo;
